import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { CustomListField } from '../../incidentForm/fields/customList/customListField';

const ListComponent = ({ field, value, onChange, disabledField }) => {
  const fieldData = useMemo(() => {
    return { ...field, value };
  }, [field, value]);

  return (
    <>
      <CustomListField field={fieldData} value={value} onChange={onChange} disabled={disabledField} />
    </>
  );
};

export default ListComponent;

ListComponent.propTypes = {
  field: PropTypes.object,
  value: PropTypes.object,
  onChange: PropTypes.func,
  disabledField: PropTypes.bool,
};
